module.exports = __webpack_public_path__ + "static/media/valerie-profile.f83e021e.png";